export default __webpack_public_path__ + "static/media/upload.01f55f36.png";